import React from 'react';
import PropTypes from 'prop-types';
import OMFiltersTitle from '../OMFiltersTitle/OMFiltersTitle';
import styles from './OMAdvancedFiltersCheckbox.scss';

const OMAdvancedFiltersCheckbox = ({ name, label, value, isMobile, onChange }) => (
  <label htmlFor={name} className={styles.wrapper}>
    <OMFiltersTitle icon={name} label={label} isMobile={isMobile} />

    <span className={styles.advancedCheckbox}>
      <input
        id={name}
        type="checkbox"
        value={value}
        checked={value}
        onChange={() => onChange(name, !value)}
      />

      <span />
    </span>
  </label>
);

OMAdvancedFiltersCheckbox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.bool,
  isMobile: PropTypes.bool,
  onChange: PropTypes.func
};

export default OMAdvancedFiltersCheckbox;
